import { ref } from 'vue';
import { ServicesContentModel } from '@/models';
import { PhoneBookService } from '@/services';

export default () => {
  const servicesContent = ref(new ServicesContentModel(PhoneBookService.getServices()));

  const displayModal = ref(false);
  const selectedServiceName = ref('');

  function selectService(serviceName) {
    selectedServiceName.value = serviceName;
    displayModal.value = true;
  }

  return {
    servicesContent,
    displayModal,
    selectedServiceName,
    selectService,
  };
};
